var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_397_6790)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.669678 9.43623C0.678844 9.41995 0.686582 9.40291 0.692803 9.38529C0.806557 8.96715 1.13438 8.71089 1.56627 8.70996C2.39442 8.7085 3.22247 8.7085 4.05041 8.70996H11.5956C12.2391 8.70996 12.4538 8.85965 12.6701 9.45998V9.97562C12.6335 10.0694 12.6076 10.1688 12.5588 10.255C12.375 10.5775 12.09 10.71 11.7222 10.7097C8.35398 10.7072 4.98585 10.7067 1.61783 10.7081C1.57877 10.7081 1.5397 10.7081 1.50064 10.706C1.32406 10.6981 1.15411 10.6365 1.01357 10.5293C0.873028 10.4221 0.768627 10.2745 0.714366 10.1062C0.699991 10.0628 0.684678 10.0194 0.669678 9.97562V9.43623Z",
    fill: "#515559"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.42167 4.20981V4.05356C5.42167 3.17103 5.42167 2.2884 5.42167 1.40566C5.42167 0.955647 5.66637 0.710952 6.11575 0.710327C6.49452 0.710327 6.87328 0.710327 7.25204 0.710327C7.66268 0.712202 7.91643 0.96471 7.91706 1.37566C7.91873 2.27006 7.91873 3.16447 7.91706 4.05887V4.20981H8.05519C8.45739 4.20981 8.85959 4.20981 9.26179 4.20981C9.43523 4.20981 9.56617 4.27731 9.6368 4.43794C9.70743 4.59857 9.66399 4.7417 9.54305 4.86671C8.68281 5.76736 7.82258 6.66822 6.96234 7.56929C6.77484 7.7643 6.55795 7.7618 6.36857 7.56492C5.51063 6.66739 4.653 5.76934 3.79568 4.87077C3.67661 4.74577 3.62818 4.60639 3.69662 4.44357C3.76505 4.28075 3.901 4.20856 4.07944 4.2095C4.5232 4.20981 4.96415 4.20981 5.42167 4.20981Z",
    fill: "#515559"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_397_6790"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.0004,
    height: 10,
    fill: "white",
    transform: "translate(0.669678 0.709351)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.0b8e7fa02e03eb011459c775df64a752.svg";
export { ForwardRef as ReactComponent };